export function parseQueryString() {
  if (location.search && location.search.indexOf("?") == 0) {
    try {
      return location.search
        .substring(1)
        .split("&")
        .reduce(function (props, seg) {
          const [key, value] = seg.split("=");
          props[key] = value;
          return props;
        }, {} as any);
    } catch (error) {
      console.error("将页面参数转换为属性对象时出错", error);
    }
  }
  return {};
}

export function formatConsole() {
  /** 非开发环境，禁用控制台打印 */
  if ((window as any).__DEV__ === false) {
    (window as any).console = {
      info: () => {},
      log: () => {},
      warn: () => {},
      debug: () => {},
      error: () => {},
      assert: () => {},
    };
  } else {
    const originalWarn = console.warn;
    console.warn = function filterWarnings(msg: any) {
      const supressedWarnings = [
        "is deprecated",
        "componentWillMount has been renamed",
        "componentWillReceiveProps has been renamed",
      ];
      if (
        !supressedWarnings.some(
          (entry) => typeof msg == "string" && msg.includes(entry)
        )
      ) {
        originalWarn.apply(console, arguments as any);
      }
    };
  }
}
